import { useState } from 'react';
import classes from './Contact.module.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        service: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        alert('Thank you for contacting us! We will get back to you soon.');
        setFormData({
            name: '',
            phone: '',
            email: '',
            service: '',
            message: ''
        });
    };

    return (
        <div className={classes.contact}>
            <div className={classes.container}>
                <h1 className={classes.pageTitle}>Contact Us</h1>
                <p className={classes.pageDescription}>
                    Get in touch with EmpireService for all your appliance repair needs. 
                    We're here to help you 24/7.
                </p>

                <div className={classes.contactGrid}>
                    <div className={classes.contactInfo}>
                        <h2>Get in Touch</h2>
                        <div className={classes.infoItem}>
                            <div className={classes.infoIcon}>📞</div>
                            <div className={classes.infoContent}>
                                <h3>Phone</h3>
                                <p><a href="tel:8879552122">+91 8879552122</a></p>
                                <p>Available 24/7</p>
                            </div>
                        </div>
                        <div className={classes.infoItem}>
                            <div className={classes.infoIcon}>✉️</div>
                            <div className={classes.infoContent}>
                                <h3>Email</h3>
                                <p><a href="mailto:empireservice022@gmail.com">empireservice022@gmail.com</a></p>
                            </div>
                        </div>
                        <div className={classes.infoItem}>
                            <div className={classes.infoIcon}>📍</div>
                            <div className={classes.infoContent}>
                                <h3>Address</h3>
                                <p>Room no 703, 17A/B, Nalasopara West Vasai-Virar 401203</p>
                            </div>
                        </div>
                        <div className={classes.infoItem}>
                            <div className={classes.infoIcon}>🕒</div>
                            <div className={classes.infoContent}>
                                <h3>Working Hours</h3>
                                <p>Monday - Sunday: 24/7</p>
                                <p>Emergency services available</p>
                            </div>
                        </div>
                    </div>

                    <div className={classes.contactForm}>
                        <h2>Book Your Service</h2>
                        <form onSubmit={handleSubmit}>
                            <div className={classes.formGroup}>
                                <label htmlFor="name">Name *</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className={classes.formGroup}>
                                <label htmlFor="phone">Phone Number *</label>
                                <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className={classes.formGroup}>
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className={classes.formGroup}>
                                <label htmlFor="service">Service Type *</label>
                                <select
                                    id="service"
                                    name="service"
                                    value={formData.service}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select a service</option>
                                    <option value="refrigerator">Refrigerator Repair</option>
                                    <option value="washing-machine">Washing Machine Repair</option>
                                    <option value="microwave">Microwave Oven Repair</option>
                                    <option value="tv">TV Repair</option>
                                    <option value="ac">AC Repair</option>
                                    <option value="music-system">Music System Repair</option>
                                    <option value="other">Other Appliance</option>
                                </select>
                            </div>
                            <div className={classes.formGroup}>
                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="4"
                                    placeholder="Describe your appliance issue..."
                                ></textarea>
                            </div>
                            <button type="submit" className={classes.submitButton}>Book Service</button>
                        </form>
                    </div>
                </div>

                <div className={classes.emergencySection}>
                    <h2>Emergency Service Available</h2>
                    <p>
                        For urgent appliance repair needs, call us directly at 
                        <a href="tel:8879552122" className={classes.emergencyNumber}> +91 8879552122</a>
                    </p>
                    <p>We provide 24/7 emergency repair services across Mumbai.</p>
                </div>
            </div>
        </div>
    );
};

export default Contact;